import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import SideMenu from "components/admin/layout/SideMenu";

const DlGroupEdit: React.FC = () => {
  return (
    <Page>
      <FullWidth>
        <div className="row">
          {/* SIDE MENU */}
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12">
            <SideMenu />
          </div>

          {/* CENTRAL CONTENT */}
          <div
            className="col-comp-central col-xl-10 col-lg-9 col-md-9 col-sm-12 offset-xl-1 offset-lg-1 offset-md-1"
            style={{ marginLeft: "15%", marginTop: "-10%" }}
          >
            <div className="App">
              <AppWrapper>
                <form>
                  <FormGroup>
                    <label htmlFor="slug">Slug</label>
                    <input
                      id="slug"
                      placeholder="slug"
                      type="text"
                      style={{ marginTop: "0.7em", padding: "0.5em" }}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label>Polja uslova:</label>
                    <FormGroup>
                      <input
                        placeholder="naziv"
                        type="text"
                        style={{ marginTop: "0.7em", padding: "0.5em" }}
                      />
                      <input
                        placeholder="vrednost"
                        type="text"
                        style={{ marginTop: "1em", padding: "0.5em" }}
                      />
                      <AddButton type="button" style={{ marginTop: "0.4em" }}>
                        Dodaj
                      </AddButton>
                    </FormGroup>
                  </FormGroup>

                  <OkButton type="button">OK</OkButton>
                </form>
              </AppWrapper>
            </div>
          </div>
        </div>
      </FullWidth>
    </Page>
  );
};

export default DlGroupEdit;

const AppWrapper = styled.div`
  width: 90%;
`;

const FormGroup = styled.div`
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;
  font-weight: 600;
`;

const AddButton = styled.button`
  width: fit-content;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  border: none;
  background-color: #555;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #666;
    color: black;
  }
`;

const OkButton = styled.button`
  margin-top: 1em;
  width: fit-content;
  padding: 0.5rem 1.2rem;
  border-radius: 6px;
  border: none;
  background-color: #d3d7dd;
  color: #000;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #3f6fb5;
    color: white;
  }
`;

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

const FullWidth = styled.div`
  width: 100%;
`;

// const Form = styled.form`
//   margin-left: 0;
// `;

// const Label = styled.label`
//   margin-bottom: 0.3rem;
//   font-weight: 500;
// `;

// const Input = styled.input`
//   width: 75%;
//   padding: 0.45rem 0.6rem;
//   border-radius: 4px;
//   border: 1px solid #ccc;
//   font-size: 0.95rem;
//   margin-bottom: 0.5rem;
// `;

// const Header = styled.header`
//   display: flex;
//   align-items: center;
// `;

// const Content = styled.div``;

// const ContentInner = styled.div`
//   width: 90%;
// `;

// const NewItem = styled.div`
//   margin-top: 0;
// `;

// const ListItem = styled.div`
//   margin-top: 1em;
//   width: 100%;
//   line-height: 1.5em;
// `;

// const DeleteText = styled.span`
//   margin-left: 3%;
//   cursor: pointer;
//   color: darkgrey;
// `;
